module.exports = __webpack_public_path__ + "img/open_World_Learning_Community.d60ff0d3.jpg";